import { Col, Row, Typography } from "antd";
import { FunctionComponent } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTE_DASHBOARD_USERS } from "../../../shared/app-constants";
import getDashboardRoute from "../../../shared/get-dashboard-route";
import UserModel from "../../../shared/user-model";
import UserForm from "../../components/user-form";
import HttpClient from "../../http-client";

interface UserCreatePageProps {}

const UserCreatePage: FunctionComponent<UserCreatePageProps> = () => {
  const navigate = useNavigate();
  const onSave = ({ id }: UserModel) => {
    navigate({
      pathname: getDashboardRoute({}, ROUTE_DASHBOARD_USERS),
    });
  };
  return (
    <Row>
      <Col span={20}>
        <Typography.Title level={4}>Create User</Typography.Title>
        <UserForm httpClient={HttpClient} onUpdate={onSave} />
      </Col>
    </Row>
  );
};

export default UserCreatePage;
